var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    foxified: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6379 13.0093L14.468 23.1792C13.2221 24.4251 11.5323 25.125 9.77038 25.125C8.00843 25.125 6.31865 24.4251 5.07277 23.1792C3.82688 21.9333 3.12695 20.2435 3.12695 18.4816C3.12695 16.7196 3.82688 15.0298 5.07277 13.784L15.2426 3.6141C16.0732 2.78351 17.1997 2.31689 18.3744 2.31689C19.549 2.31689 20.6755 2.78351 21.5061 3.6141C22.3367 4.44469 22.8033 5.57121 22.8033 6.74585C22.8033 7.92048 22.3367 9.047 21.5061 9.87759L11.3252 20.0474C10.9099 20.4627 10.3466 20.6961 9.75931 20.6961C9.172 20.6961 8.60874 20.4627 8.19344 20.0474C7.77815 19.6322 7.54484 19.0689 7.54484 18.4816C7.54484 17.8943 7.77815 17.331 8.19344 16.9157L17.5887 7.53155",
    stroke: "#1DA1F2",
    strokeWidth: 2.21324,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.6349d97dd37ddebe8a061f715705e6a9.svg";
export { ForwardRef as ReactComponent };